module.exports = __webpack_public_path__ + "img/feedback2.671a7aba.png";